<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <CompanyInput v-if="isEpson" :label="$t('ELE0134')" v-model="searchCondition.supplierCd" />
            <ManufacturerInput v-else :label="$t('ELE0134')" v-model="searchCondition.supplierCd" />
          </v-col>
          <v-col cols="6">
            <PartCodeInput v-if="isEpson" v-model="searchCondition.partCd" />
            <SupplierPartInput v-else v-model="searchCondition.partCd" :supplierCd="''" isSearchByLoginCompany />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <TextFieldInputWithDatePicker :label="$t('ELE0207')" v-model="searchCondition.fromExpDate" clearable />
          </v-col>
          <span class="px-4 py-5"> {{ $t('ELE0141') }} </span>
          <v-col>
            <TextFieldInputWithDatePicker :label="$t('ELE0207')" v-model="searchCondition.toExpDate" clearable />
          </v-col>
          <v-col>
            <Checkbox v-model="searchCondition.isExpiredXrf" :label="$t('ELE0341')" />
          </v-col>
          <v-col class="d-flex justify-end">
            <BtnSearch @click="onClickSearch" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title class="pt-1 pb-0">
                {{ $t('ELE0023') }}
                <v-spacer />
              </v-card-title>
              <v-data-table :headers="headers" :items="xrfSearchList" dense>
                <template v-slot:item="{ item }">
                  <tr :style="item.isExpired ? 'background-color: #F8CED2' : ''">
                    <td class="v-data-table__divider">{{ item.supplier }}</td>
                    <td class="v-data-table__divider">{{ item.inspDate }}</td>
                    <td class="v-data-table__divider">{{ item.partCd }}</td>
                    <td class="v-data-table__divider">{{ item.partName }}</td>
                    <td class="v-data-table__divider text-end">{{ item.cycleDays }}</td>
                    <td>{{ item.expDate }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import PartCodeInput from '@/components/atoms/select/PartCodeInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import CompanyInput from '@/components/atoms/select/CompanyInput'
import ManufacturerInput from '@/components/atoms/select/ManufacturerInput'
import SupplierPartInput from '@/components/atoms/select/SupplierPartInput'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'

export default {
  name: 'SearchInspBoxForm',
  mixins: [APIUtils, Message, Loading, DateUtils],
  components: {
    PartCodeInput,
    TextFieldInputWithDatePicker,
    BtnSearch,
    CompanyInput,
    ManufacturerInput,
    SupplierPartInput,
    Checkbox,
  },
  data() {
    return {
      searchCondition: {
        supplierCd: '',
        partCd: '',
        fromExpDate: '',
        toExpDate: '',
        isExpiredXrf: true,
      },
      headers: [
        { text: this.$t('ELE0134'), value: 'supplier' },
        { text: this.$t('ELE0138'), value: 'inspDate' },
        { text: this.$t('ELE0031'), value: 'partCd' },
        { text: this.$t('ELE0032'), value: 'partName' },
        { text: this.$t('ELE0214'), value: 'cycleDays' },
        { text: this.$t('ELE0207'), value: 'expDate' },
      ],
      xrfSearchList: [],
    }
  },
  computed: {
    isEpson: {
      get() {
        return this.$store.getters.isEpson
      },
    },
  },
  methods: {
    async onClickSearch() {
      this.startLoading()
      try {
        const params = { ...this.searchCondition, userCompanyCd: this.isEpson ? '' : this.$store.getters.companyCd }
        const data = await API.get('/gns/getXrfData', params)
        if (data) {
          this.xrfSearchList = data.map((item) => {
            return {
              supplier: `${item.otclLifnr}: ${item.companyName}`,
              inspDate: this.toLocalDate(item.xrfLastDatetime),
              partCd: item.otclMatnr,
              partName: item.partName,
              cycleDays: item.otclXrfcycle,
              expDate: this.toLocalDate(item.expirationDate),
              isExpired: item.isExpired,
            }
          })
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0170') })))
      } finally {
        this.stopLoading()
      }
    },
  },
  mounted() {
    this.onClickSearch()
  },
}
</script>
